import { createAction, props } from "@ngrx/store";
import { ThanksYouState } from "./thank-you.state";

export const setThankYou = createAction("[THANKYOU] SET_THANK_YOU", props<{ thankYou: ThanksYouState }>());
